import * as LabelPrimitive from "@radix-ui/react-label";
import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";

import { generateValidClassNameHandler } from "@/lib/utils";

const labelVariants = cva("text-xs text-gray-500 peer-disabled:cursor-not-allowed peer-disabled:opacity-70 md:text-sm");

const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> &
    VariantProps<typeof labelVariants>
>(({
    className,
    ...props
}, ref) => (
    <LabelPrimitive.Root
        ref={ref}
        className={generateValidClassNameHandler(
            labelVariants(),
            className,
        )}
        {...props}
    />
));
Label.displayName = LabelPrimitive.Root.displayName;

export { Label };
